import { useEffect, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { ITreeNode, resolveTreeItemFromQuery } from './treeUtils';

const useQuery = () => {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
};

const useSecTreeItem = (secTreeHierarchy: ITreeNode | Record<string, unknown>) => {
  const history = useHistory();
  const query = useQuery();
  const hierarchy = secTreeHierarchy as ITreeNode;
  const isTreeItemReady = Boolean(hierarchy?.uid);
  const rootFromQuery = query.get('root');
  const treeItem = useMemo(
    () => resolveTreeItemFromQuery(rootFromQuery, hierarchy),
    [rootFromQuery, hierarchy]
  );

  useEffect(() => {
    if (!isTreeItemReady || !rootFromQuery || treeItem === rootFromQuery) {
      return;
    }

    history.replace('?root=' + treeItem);
  }, [history, isTreeItemReady, rootFromQuery, treeItem]);

  return { treeItem, rootFromQuery, isTreeItemReady };
};

export default useSecTreeItem;
